import { useMediaQuery } from '@mantine/hooks';
import type { ReactNode } from 'react';

function Rail({ children }: { children: ReactNode }) {
  return (
    <aside className="min-w-0 flex-1 [contain:size] print:hidden">
      <div className="sticky top-0 flex h-full max-h-[calc(100dvh-4rem)] flex-col items-center justify-center pt-8 pb-20">
        {children}
      </div>
    </aside>
  );
}

export function PageShell({
  header,
  label,
  left,
  right,
  children,
}: {
  header: ReactNode;
  label?: string;
  /** Desktop-only content beside the page. */
  left?: ReactNode;
  right?: ReactNode;
  children: ReactNode;
}) {
  // Matches Tailwind's `xl`. Unmounted below it, side content loads nothing.
  const wide = useMediaQuery('(min-width: 80rem)', false, {
    getInitialValueInEffect: false,
  });
  const rails = wide && (left || right);
  return (
    <div className="flex min-h-dvh flex-col">
      {header}
      <div className="flex grow justify-center gap-2 xl:px-8">
        {rails ? <Rail>{left}</Rail> : null}
        <main
          aria-label={label}
          className="max-w-content flex w-full grow flex-col px-6 py-8 print:max-w-none print:p-0"
        >
          {children}
        </main>
        {rails ? <Rail>{right}</Rail> : null}
      </div>
    </div>
  );
}
